import { useState } from 'react';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';

// A dropdown of grouped action buttons. Each group is { title, items, danger }; empty groups are hidden.
// A danger group has no heading, just a line above it, so its actions still sit apart at the bottom.
// The menu stays mounted after it closes, so a modal opened from one of its buttons stays open.
export default function ActionsMenu({ groups = [], label = 'Actions' }) {
  const [open, setOpen] = useState(false);

  const visibleGroups = groups
    .map((group) => ({ ...group, items: (group.items || []).filter(Boolean) }))
    .filter((group) => group.items.length > 0);

  if (visibleGroups.length === 0) return null;

  const menu = (
    <div className="actions-menu" onClick={() => setOpen(false)}>
      {visibleGroups.map((group) => (
        <div key={group.title} className={group.danger ? 'actions-menu-danger-group' : undefined}>
          {!group.danger && <div className="actions-menu-title">{group.title}</div>}
          {group.items}
        </div>
      ))}
    </div>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" open={open} onOpenChange={setOpen}>
      <Button type="primary">{label} <DownOutlined /></Button>
    </Dropdown>
  );
}
